// ABS CPI data for June quarter (annual)
// Source: Australian Bureau of Statistics - Consumer Price Index
// https://www.abs.gov.au/statistics/economy/price-indexes-and-inflation/consumer-price-index-australia
const CPIData = {
  2000: { value: 3.0, isProjected: false },
  2001: { value: 6.0, isProjected: false },
  2002: { value: 2.8, isProjected: false },
  2003: { value: 2.8, isProjected: false },
  2004: { value: 2.5, isProjected: false },
  2005: { value: 2.5, isProjected: false },
  2006: { value: 4.0, isProjected: false },
  2007: { value: 2.1, isProjected: false },
  2008: { value: 4.5, isProjected: false },
  2009: { value: 1.5, isProjected: false },
  2010: { value: 3.1, isProjected: false },
  2011: { value: 3.6, isProjected: false },
  2012: { value: 1.2, isProjected: false },
  2013: { value: 2.4, isProjected: false },
  2014: { value: 3.0, isProjected: false },
  2015: { value: 1.5, isProjected: false },
  2016: { value: 1.0, isProjected: false },
  2017: { value: 1.9, isProjected: false },
  2018: { value: 2.1, isProjected: false },
  2019: { value: 1.6, isProjected: false },
  2020: { value: -0.3, isProjected: false },
  2021: { value: 3.8, isProjected: false },
  2022: { value: 6.1, isProjected: false },
  2023: { value: 6.0, isProjected: false },
  2024: { value: 3.8, isProjected: false },
  2025: { value: 2.8, isProjected: true },
  2026: { value: 2.5, isProjected: true },
  2027: { value: 2.5, isProjected: true },
  2028: { value: 2.5, isProjected: true },
  2029: { value: 2.5, isProjected: true },
  2030: { value: 2.5, isProjected: true }
};

export default CPIData;
